var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Portal } from "./..";
import styled, { createGlobalStyle } from "../../styled";
import { addAriaHidden, removeAriaHidden } from './ariaHiddenHandler';
import { Backdrop } from './Backdrop';
var StyledModal = styled.div(function (_a) {
    var isOpen = _a.isOpen, theme = _a.theme;
    return "\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: " + theme.zIndices.modal + ";\n  position: fixed;\n  visibility: " + (!isOpen && 'hidden') + ";\n";
});
var BodyOverflow = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body {\n    overflow: hidden;\n  }\n"], ["\n  body {\n    overflow: hidden;\n  }\n"])));
var StyledContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n"])));
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalRef = React.createRef();
        _this.lastFocus = null;
        _this.mouseDownTarget = null;
        _this.handleClose = function () {
            var _a;
            removeAriaHidden();
            _this.handleRestoreLastFocus();
            (_a = _this.modalRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('focus', _this.handleFocus, true);
        };
        _this.handleOpened = function () {
            _this.handleFocus();
            if (_this.modalRef.current) {
                addAriaHidden(_this.modalRef.current);
                _this.modalRef.current.scrollTop = 0;
            }
        };
        _this.handleFocus = function () {
            if (_this.modalRef.current) {
                var lastActiveElement = document.activeElement;
                if (!_this.modalRef.current.contains(lastActiveElement)) {
                    if (!_this.modalRef.current.hasAttribute('tabIndex')) {
                        _this.modalRef.current.setAttribute('tabIndex', '-1');
                    }
                    _this.lastFocus = lastActiveElement;
                    _this.modalRef.current.focus();
                }
            }
        };
        _this.handleRestoreLastFocus = function () {
            if (!_this.lastFocus) {
                return;
            }
            if (_this.lastFocus.focus) {
                _this.lastFocus.focus();
            }
            _this.lastFocus = null;
        };
        _this.handleMouseDown = function (event) {
            _this.mouseDownTarget = event.target;
        };
        _this.handleBackdropClick = function (event) {
            var onClose = _this.props.onClose;
            if (!onClose ||
                event.target !== event.currentTarget ||
                event.target !== _this.mouseDownTarget) {
                return;
            }
            _this.mouseDownTarget = null;
            onClose(event);
        };
        _this.handleKeyDown = function (event) {
            // pressed ESC
            if (event.keyCode !== 27 || event.defaultPrevented) {
                return;
            }
            event.stopPropagation();
            if (_this.props.onClose && _this.props.closeOnEscPress) {
                _this.props.onClose(event);
            }
        };
        return _this;
    }
    Modal.prototype.componentDidMount = function () {
        var _a;
        (_a = this.modalRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('focus', this.handleFocus, true);
        this.handleOpened();
    };
    Modal.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isOpen && !this.props.isOpen) {
            //closed
            this.handleClose();
        }
        else if (!prevProps.isOpen && this.props.isOpen) {
            //opened
            this.lastFocus = document.activeElement;
            this.handleOpened();
        }
    };
    Modal.prototype.componentWillUnmount = function () {
        if (this.props.isOpen) {
            this.handleClose();
        }
    };
    Modal.prototype.render = function () {
        var _a = this.props, children = _a.children, isOpen = _a.isOpen, hideBackdrop = _a.hideBackdrop, props = __rest(_a, ["children", "isOpen", "hideBackdrop"]);
        if (!isOpen)
            return null;
        return (React.createElement(Portal, null,
            isOpen && React.createElement(BodyOverflow, null),
            React.createElement(StyledModal, __assign({ role: "presentation", ref: this.modalRef, onKeyDown: this.handleKeyDown, isOpen: isOpen }, props),
                !hideBackdrop && React.createElement(Backdrop, null),
                React.createElement(StyledContent, { onClick: this.handleBackdropClick, onMouseDown: this.handleMouseDown }, children))));
    };
    Modal.defaultProps = {
        isOpen: false,
        closeOnEscPress: false,
        hideBackdrop: false
    };
    return Modal;
}(React.Component));
export { Modal };
var templateObject_1, templateObject_2;
//# sourceMappingURL=Modal.js.map